import React from "react";

import LoaderIcon from "@assets/images/drsLoader.gif";

const MainPageLoader = ({ styleProp = { width: 60, height: 60 } }) => {
  return <img src={LoaderIcon} alt="LoaderIconForDrs" style={styleProp} />;
};

export default React.memo(MainPageLoader);